/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Azi',
  now: 'Acum',
  backToToday: 'Ãnapoi la azi',
  ok: 'Ok',
  clear: 'Èterge',
  month: 'LunÄ',
  year: 'An',
  timeSelect: 'selecteazÄ timpul',
  dateSelect: 'selecteazÄ data',
  weekSelect: 'Alege o sÄptÄmÃ¢nÄ',
  monthSelect: 'Alege o lunÄ',
  yearSelect: 'Alege un an',
  decadeSelect: 'Alege un deceniu',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Luna anterioarÄ (PageUp)',
  nextMonth: 'Luna urmÄtoare (PageDown)',
  previousYear: 'Anul anterior (Control + stÃ¢nga)',
  nextYear: 'Anul urmÄtor (Control + dreapta)',
  previousDecade: 'Deceniul anterior',
  nextDecade: 'Deceniul urmÄtor',
  previousCentury: 'Secolul anterior',
  nextCentury: 'Secolul urmÄtor'
};
